import React from "react";
import "./style.css";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import SwiperCore from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import { Button, Typography, Link as MuiLink, Box } from "@mui/material";
import { useMediaQuery } from "react-responsive";
import useSystemHook from "./../../hooks/SystemHook";
import { COLORS } from "../../constants";

SwiperCore.use([Autoplay, Navigation]);

const Hero = () => {
  const { isMobile, isTablet, isDesktop } = useSystemHook();

  const getBannerImage = (mobileNum, desktopNum) =>
    `https://argusweb.azureedge.net/argus-web/trade-show/banners/Banners-${
      isMobile ? mobileNum : desktopNum
    }.webp`;

  const heroItems = [
    // {
    //   showButton: false,
    //   image: () => getBannerImage("01-mobile", "01"),
    // },
    {
      showButton: true,
      image: () => getBannerImage("17", "14"),
      // buttonText: "Learn More",
      // headingText: "Established in 1955",
      link: "/about",
    },
    {
      showButton: true,
      image: () => getBannerImage("06", "03"),
      // buttonText: "Go",
      // headingText: "Meet the Team",
      link: "/team",
    },
    // {
    //   showButton: true,
    //   image: () => getBannerImage("08", "07"),
    //   buttonText: "Go",
    //   link: "/tradeshow",
    // },
  ];

  return (
    <section>
      <Swiper
        modules={[Autoplay, Navigation]}
        spaceBetween={50}
        slidesPerView={1}
        navigation
        loop={true}
        pagination={{ clickable: true }}
        autoplay={{
          delay: 3000,
          disableOnInteraction: true,
        }}
      >
        {!!heroItems &&
          heroItems.map((item, index) => {
            const heroImage = item.image();
            return (
              <SwiperSlide key={index}>
                <MuiLink
                  component={Link}
                  to={item.link}
                  sx={{ textDecoration: "none" }}
                >
                  <Box
                    sx={{
                      position: "relative",
                      width: "100%",
                      // height: { xs: "30vh", md: "60vh" },
                      overflow: "hidden",
                      mb: -1,
                    }}
                  >
                    {!!item.showButton && (
                      <Box
                        sx={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          backgroundColor: isMobile
                            ? "rgba(0, 0, 0, 0.2)"
                            : "rgba(0, 0, 0, 0.3)",
                          transition: "background-color 0.5s ease",
                          "&:hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                          },
                          zIndex: 1,
                        }}
                      />
                    )}

                    <img
                      src={heroImage}
                      alt={`Slide ${index + 1}`}
                      style={{
                        width: "100%",
                        objectFit: "cover",
                        objectPosition: "center",
                      }}
                    />

                    {item.showButton && (
                      <Box
                        sx={{
                          position: "absolute",
                          top: "50%",
                          left: 0,
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          color: COLORS.white,
                          zIndex: 2,
                        }}
                      >
                        <Typography
                          variant={isMobile ? "h6" : "h4"}
                          sx={{ mb: 2, color: "#fff" }}
                        >
                          {item.headingText}
                        </Typography>
                        {/* <Button
                          variant="contained"
                          size="small"
                          sx={{
                            backgroundColor: COLORS.themeYellow,
                            color: COLORS.themeBlack,
                            px: isMobile ? 5 : 7,
                            py: isMobile ? 1 : 1.5,
                            borderRadius: "2px",
                            fontSize: isMobile
                              ? "var(--font-size-xxs)"
                              : "var(--font-size-s)",
                            "&:hover": {
                              backgroundColor: COLORS.themeRed,
                              color: COLORS.white,
                            },
                          }}
                        >
                          {item.buttonText}
                        </Button> */}
                      </Box>
                    )}
                  </Box>
                </MuiLink>
              </SwiperSlide>
            );
          })}
      </Swiper>
    </section>
  );
};

export default Hero;
